import Tile from '@commons/components/Tile/Tile';

import type { IntelligenceNodeProps } from '.';

/**
 * Intelligence node component for the Tile display type.
 */

const IntelligenceNodeTile = ({ image, title, alias }: IntelligenceNodeProps) => (
  <Tile href={alias} title={title} image={image} />
);

export default IntelligenceNodeTile;
